/**
 * Password change form validation schema
 * Validates password complexity and confirmation matching
 */

import * as Yup from 'yup'
import { FORM_LABELS, LABELS } from '@constants'

/**
 * Password validation schema with complexity requirements
 * - Minimum 8 characters
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one number
 * - Confirmation must match
 */
export const passwordChangeValidationSchema = () =>
  Yup.object().shape({
    current_password: Yup.string().required(FORM_LABELS.REQUIRED('Huidig wachtwoord')),

    new_password: Yup.string()
      .required(FORM_LABELS.REQUIRED('Nieuw wachtwoord'))
      .min(8, FORM_LABELS.PASSWORD_MIN_LENGTH)
      .matches(/[A-Z]/, FORM_LABELS.PASSWORD_UPPERCASE_REQUIRED)
      .matches(/[a-z]/, FORM_LABELS.PASSWORD_LOWERCASE_REQUIRED)
      .matches(/[0-9]/, FORM_LABELS.PASSWORD_NUMBER_REQUIRED),

    new_password_confirmation: Yup.string()
      .required(FORM_LABELS.REQUIRED('Bevestig nieuw wachtwoord'))
      .oneOf([Yup.ref('new_password')], FORM_LABELS.PASSWORDS_MUST_MATCH),
  })
